import { render, staticRenderFns } from "./ShowVoucher.vue?vue&type=template&id=1bfff810"
import script from "./ShowVoucher.vue?vue&type=script&lang=js"
export * from "./ShowVoucher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports